import { get } from "api/axiosApi";
import { env } from "utils/env";

const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;

const getPartnersList = search => {
  return get(`${masterPartnerUrl}/Partners/partners?search=${search}`);
};

const getPartnerDetails = uniqueId => {
  return get(`${masterPartnerUrl}/partners/${uniqueId}/partner-with-shareholders`);
};

const exp = {
  getPartnersList,
  getPartnerDetails
};
export default exp;
